// Колокольчик из макета (37×37). Бейдж с числом непрочитанных в макете
// нарисован прямо в иконке — здесь его нет: он живой и рисуется поверх
// (см. шапку главной).
//
// В макете колокольчик смещён влево-вниз (центр в 16,21), освобождая угол
// под бейдж; в ряду с поиском и языком это выглядело криво. viewBox того же
// размера, но с центром на самом колокольчике — масштаб прежний, стоит ровно.
export const NotificationIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="-2.5 2.5 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M24.2489 17.6532V18.5236C24.2489 19.5681 24.5437 20.5893 25.096 21.4584L26.4495 23.5883C27.6859 25.5337 26.7421 28.1778 24.5917 28.7931C18.9667 30.4023 13.0333 30.4023 7.40822 28.7931C5.25795 28.1778 4.31411 25.5337 5.55044 23.5883L6.90398 21.4584C7.45632 20.5893 7.75106 19.5681 7.75106 18.5236V17.6532C7.75106 12.8742 11.4442 9 16 9C20.5557 9 24.2489 12.8742 24.2489 17.6532Z"
      fill="currentColor"
    />
    <path
      d="M10 29C10.8211 31.3216 13.197 33 16 33C18.803 33 21.1788 31.3216 22 29C18.0323 29.6835 13.9676 29.6835 10 29Z"
      fill="currentColor"
    />
  </svg>
);
